<template>
	<div>
		<button class="mortgage-calcnew__sbutton" @click="sliderNext()" v-show="sliderNextShow">Next</button>
		<div class="mortgage-calcnew__curtain-left"></div>
		<button class="mortgage-calcnew__lbutton" @click="sliderPrevious()" v-show="sliderPreviousShow">Previous</button>
		<div class="mortgage-calcnew__curtain"></div>
		<section class="mortgage-calcnew__regular">
			<div class="mortgage-calcnew__slide"
			v-for="(product, index) in products"
			:key="index"
			:class="{'mortgage-calcnew__slide_active': slidesText === product.code }"
			@click="sliderText(product.code)"
			v-show="sliderCounter === index || sliderCounter < index + 1"
			:data-value="'mortgage-calcnew__i'+product.code">
			<div class="mortgage-calcnew__ileft" :data-value="'mortgage-calcnew__i'+product.code">
				<div class="mortgage-calcnew__iwrapper" :data-value="'mortgage-calcnew__i'+product.code"></div>
				<div class="mortgage-calcnew__ttext" :data-value="'mortgage-calcnew__i'+product.code" v-html="product.name"></div>
			</div>
			<div class="mortgage-calcnew__photo" :class="'mortgage-calcnew__photo_'+product.code" :data-value="'mortgage-calcnew__i'+product.code"></div>
			</div>
		</section>
		<div class="mortgage-calcnew__slides-text" v-show="slidesTextShow">
			<div :key="index" v-for="(info, index) in information" v-show="slidesText === info.code" v-html="info.text"> </div>
		</div>
	</div>
</template>

<script>
import { getQueryParameterByName } from '../../../assets/js/utils';

export default {
	name: "MortgageCalculatorSlider",
	props: {
		products: {
			type: Array
		},
		slidesText: {
			type: String,
			default: ''
		},
		information: {
			type: Array
		},
		targets: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			sliderCounter: 0
		}
	},
	methods: {
		sliderNext() {
			this.sliderCounter++;
		},
		sliderPrevious() {
			this.sliderCounter--;
		},
		sliderText(product) {
			this.$emit('sliderText', product);
		}
	},
	computed: {
		sliderNextShow() {
			return this.sliderCounter < this.$props.products.length - 2
		},
		sliderPreviousShow() {
			return this.sliderCounter !== 0
		},
		slidesTextShow() {
			return this.$props.slidesText !== '' && this.$props.slidesText !== 'med' && this.$props.slidesText !== 'scientist'
		}
	},
	watch: {
		targets(value) {
			if (value === 'product_refinancing') {
				this.sliderCounter = 0;
			}
		}
	},
	mounted() {
		if (getQueryParameterByName('utm_content') === 'dalnevostochnaya') {
			this.sliderCounter = 3;
		}
		else if (getQueryParameterByName('utm_content') === 'selskaya') {
			this.sliderCounter = 4;
		}
	}
}
</script>
